import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Loĝis sur la skribotablo du amikoj-krajonoj, Akra kaj Malakra. 
      La Akra Krajonjo laboris de mateno ĝis vespero: pentris, desegnis, liniis. Oni lin akrigis, eĉ rabotaĴo ŝprucis, kaj premis ĝis rompo. 
      Sed la Malakran Krajonon oni tute ne tuŝis: lia koro estis tro malmola.
      Kaj oni scias ja, ke malmola koro al nenio utilas.
    </p>
    
    <p class="mb-3">
      Rigardas la Malakra Krajono al vervo de sia kamarado kaj miras:
    </p>
    
    <p class="mb-3">
      - Nu kial vi vin eluzas? 
      Por kio tio bezonatas?
    </p>
    
    <p class="mb-3">
      - Por mi ja tiel interese estas labori, vivi, fari ion novan…
    </p>
    
    <p class="mb-3">
      - Jes, interese, sed la sano ja foriras. 
      Jen, kia magra kaj eta vi fariĝis! 
      Baldaŭ de vi tute nenio restos!
    </p>
    
    <p class="mb-3">
      - Ne gravas! – gaje respondas la Akra. 
      – Da mi sufiĉas ankoraŭ!
    </p>
    
    <p class="mb-3">
      Sed la tempo pasas, kaj vere, de la Akra Krajono restis nenio. 
      Lin anstataŭigis aliuj Krajonoj, kiuj kun granda amo kaj estimo rememoris sian antaŭulon.
    </p>
    
    <p class="mb-3">
      - Mi konis lin persone! – fiere eksklamis la Malakra Krajono. 
      – Li estis mia plej bona amiko, kredu min!
    </p>
    
    <p class="mb-3">
      - Vi konis lin? – admiras la junaj akruloj. 
      – Eble, vi skribos memuarojn pri li?
    </p>
    
    <p class="mb-3">
      Kaj la Malakra komencis skribi memuarojn.
    </p>
    
    <p class="mb-3">
      Kompreneble, li ne mem verkis kaj skribis: li estis tro malakra por tio. 
      La junaj Akraj Krajonoj demandis lin kaj priskribis la eventojn laŭ liaj vortoj. 
      Tio estas malfacila afero: ja Malakra multon forgesis, multon konfuzis, kaj multon simple ne povis esprimi. 
      La Akruloj devas korekti, aldoni, ŝanĝi…
    </p>
    
    <p class="mb-3">
      La malakrulo verkas memuarojn…
    </p>
    `
  )
}

const itemName = {
  esp: 'Memoraĵoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;